import React from 'react';
import { FiCheckSquare, FiCopy, FiFolder, FiSquare, FiTrash2, FiX } from 'react-icons/fi';

/** Full-width selection strip (shown below breadcrumbs, not in the top toolbar). */
export default function StorageBoxBulkSelectBar({
  checkedCount,
  totalSelectable,
  busy = false,
  onExitSelectMode,
  onSelectAll,
  onSelectNone,
  onDelete,
  onMoveTo,
  onCopyTo,
}) {
  const allSelected = totalSelectable > 0 && checkedCount >= totalSelectable;

  return (
    <div className="sb-drive-selection-strip" role="toolbar" aria-label="Selection actions">
      <div className="sb-drive-selection-strip__group sb-drive-selection-strip__group--meta">
        <span className="sb-drive-selection-strip__count" title={`${checkedCount} selected`}>
          <span className="sb-drive-selection-strip__count-num">{checkedCount}</span>
          <span className="sb-drive-selection-strip__count-suffix"> selected</span>
        </span>
        <span className="sb-drive-selection-strip__divider" aria-hidden />
        <button
          type="button"
          className="sb-drive-selection-strip__link"
          onClick={onSelectAll}
          disabled={busy || allSelected}
          title="Select all"
          aria-label="Select all"
        >
          <FiCheckSquare className="sb-drive-selection-strip__link-icon" aria-hidden />
          <span className="sb-drive-selection-strip__link-label">Select all</span>
        </button>
        <button
          type="button"
          className="sb-drive-selection-strip__link"
          onClick={onSelectNone}
          disabled={busy || checkedCount === 0}
          title="Select none"
          aria-label="Select none"
        >
          <FiSquare className="sb-drive-selection-strip__link-icon" aria-hidden />
          <span className="sb-drive-selection-strip__link-label">Select none</span>
        </button>
      </div>

      <div className="sb-drive-selection-strip__group sb-drive-selection-strip__actions">
        <button
          type="button"
          className="sb-drive-selection-strip__action"
          onClick={onCopyTo}
          disabled={busy || checkedCount === 0}
          title="Copy to"
          aria-label="Copy to"
        >
          <FiCopy aria-hidden />
          <span className="sb-drive-selection-strip__action-label">Copy to</span>
        </button>
        <button
          type="button"
          className="sb-drive-selection-strip__action"
          onClick={onMoveTo}
          disabled={busy || checkedCount === 0}
          title="Move to"
          aria-label="Move to"
        >
          <FiFolder aria-hidden />
          <span className="sb-drive-selection-strip__action-label">Move to</span>
        </button>
        <button
          type="button"
          className="sb-drive-selection-strip__action sb-drive-selection-strip__action--icon sb-drive-selection-strip__action--danger"
          onClick={onDelete}
          disabled={busy || checkedCount === 0}
          title="Delete"
          aria-label="Delete"
        >
          <FiTrash2 aria-hidden />
        </button>
        <button
          type="button"
          className="sb-drive-selection-strip__action sb-drive-selection-strip__action--icon sb-drive-selection-strip__done"
          onClick={onExitSelectMode}
          disabled={busy}
          aria-label="Done selecting"
          title="Done"
        >
          <FiX aria-hidden />
        </button>
      </div>
    </div>
  );
}
